import { connect } from 'react-redux';
import TotalCard from './totalCard';

export default connect()(TotalCard);
